import { render, staticRenderFns } from "./AllArticles.vue?vue&type=template&id=5f908be3&"
import script from "./AllArticles.vue?vue&type=script&lang=ts&"
export * from "./AllArticles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports